import { useEffect, useState } from 'react';
import { ICountryDetail } from '../../../../types/countries';
import { displayErrorNotification } from '../../../../utils/displayNudosStandardNotifications';
import { countriesList } from '../../../../services/countriesList';
import GenericLoader from '../../../../components/GenericLoader';
import { CountryCard } from './Components';

import './AddNewCity.scss';

const AddNewCity = () => {
  const [countriesData, setCountriesData] = useState<ICountryDetail[]>();
  const [loading, setLoading] = useState<boolean>(false);

  const getCountriesList = async () => {
    setLoading(true);
    try {
      const countriesData = await countriesList();
      if (countriesData) {
        setCountriesData(countriesData);
      }
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCountriesList();
  }, []);

  return (
    <div id="addNewCity">
      {loading ? (
        <div className="loaderCountriesList">
          <GenericLoader />
        </div>
      ) : (
        <div className="countriesContainer">
          {countriesData &&
            countriesData.length > 0 &&
            countriesData.map((item, index) => {
              return <CountryCard key={`countryCardName-${item.name}-index-${index}`} countryData={item} />;
            })}
        </div>
      )}{' '}
    </div>
  );
};

export default AddNewCity;
